import ModalIf from '@common/ModalIf'
import JiaMengInfo from '@components/JiaMeng/HomeInfo'
import JiaMengBindWechat from '@components/JiaMeng/HomeInfo/BindWechat'
import JiaMengCheckIn from '@components/JiaMeng/HomeInfo/CheckIn'
import JiaMengSchedule from '@components/JiaMeng/HomeInfo/Schedule'
import { isHotelProperty } from '@merchant-backend/util'
import { getMerchantInfo, isExperienceStore, isNewOpen } from '@util'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import Activity from './Activity'
import AuthenticationModal from './AuthenticationModal'
import CommercialSchool from './CommercialSchool'
import CommonUse from './CommonUse'
import ContactUs from './ContactUs'
import CouponModal from './CouponModal'
import CPTAdvertiseModal from './CPTAdvertiseModal'
import CurrentSituation from './CurrentSituation'
import ExclusiveCode from './ExclusiveCode'
import Info from './Info'
import MarketingActivity from './MarketingActivity'
import NewerGuide from './NewerGuide'
import NewMerchantTaskPanel from './NewMerchantTaskPanel'
import Notice from './Notice'
import PosterM from './PosterM'
import PosterPopup from './PosterPopup'
import Product from './Product'
import RhinocerosAcademy from './RhinocerosAcademy'
import RightFloatModal from './RightFloatModal'
import store from './store'
import styles from './style.module.less'
import SubStoreUnbind from './SubStoreUnbind'
import TaskOfOpeningShop from './TaskOfOpeningShop'
import TopTip from './TopTip'
import TouTiao from './TouTiao'
import UpgradeTips from './UpgradeTips'
import YesterdayData from './YesterdayData'
import Tracker from '@components/Tracker'
@observer
export default class extends Component {
  async componentDidMount() {
    store.checkNeed()
    await store.getTouTiao()
    await store.getShowModules()
    await store.getZhituibaoModal()
    window.addEventListener('resize', store.onWindowResize)
    store.onWindowResize()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', store.onWindowResize)
  }

  render() {
    const { bankModal, onCancelBank } = store
    const { new_guidelines = [] } = getMerchantInfo()

    return (
      <Tracker mode={['page']} data={Tracker.trackBuild('首页-进入/退出')}>
        <div className={styles.box}>
          <TopTip />
          {isNewOpen() ? (
            <TaskOfOpeningShop />
          ) : (
            <div className={styles.home}>
              <div className={styles.left}>
                <JiaMengInfo />
                <UpgradeTips />
                <Info />
                <RhinocerosAcademy />
                <CurrentSituation />
                <TouTiao />
                <YesterdayData />
                <CommonUse />
                <CommercialSchool />
              </div>

              <div className={styles.right}>
                {/* 各种弹框提醒 */}
                {!isExperienceStore() && <JiaMengBindWechat />}
                {!isExperienceStore() && <JiaMengCheckIn />}
                {!isExperienceStore() && <JiaMengSchedule />}
                <MarketingActivity />
                {!isHotelProperty() && <NewMerchantTaskPanel />}

                {/* <Evaluate />  TODO  店铺评分，不需要了 ？ */}
                <Product />
                <ExclusiveCode />
                <Notice />
                <Activity />
                <ContactUs />
              </div>
            </div>
          )}

          <ModalIf
            type={bankModal.type}
            isShow={bankModal.isShow}
            content={bankModal.content}
            btn1={bankModal.btn1}
            btn2={bankModal.btn2}
            hrefVal={bankModal.hrefVal}
            onClick={onCancelBank}
          />
          <AuthenticationModal />
          {/*<SiteManagementModal />*/}
          <PosterM />

          {/* 商家Web端首页弹窗, 180806 言溪 */}
          <PosterPopup />

          {/* 商家Web端悬浮窗, 180806 言溪 */}
          <RightFloatModal />

          {/* 优惠券 poster */}
          {<CouponModal />}

          {/* CPT提醒弹窗 */}
          <CPTAdvertiseModal />

          <SubStoreUnbind />

          {/* 新手指导蒙层 */}
          {!!new_guidelines.length && <NewerGuide />}
        </div>
      </Tracker>
    )
  }
}
